import { render, staticRenderFns } from "./referral-step.vue?vue&type=template&id=574b24c9&"
import script from "./referral-step.vue?vue&type=script&lang=js&"
export * from "./referral-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports